module.exports = __webpack_public_path__ + "d.no2.504a76df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/d.no2.jpg
// module id = JhHZ
// module chunks = 0